import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { PageLoader } from '@/components/feedback/PageLoader'
import { router } from './router'
import { AuthProvider } from './AuthContext'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './queryClient'

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Suspense fallback={<PageLoader />}>
          <RouterProvider router={router} />
        </Suspense>
      </AuthProvider>
    </QueryClientProvider>
  )
}
